import { signInMethods } from './signInMethods'
import { derived } from 'svelte/store'

export const userHasPassword = derived(signInMethods, ($signInMethods) => {
	return $signInMethods.includes('password')
})
